// apps/frontend/src/components/AchievementToast.tsx
// Toast Glowp pour les achievements — affiché en bas-centre, gradient brand,
// auto-dismiss après 5s. Écoute le handler setté dans lib/achievements.ts.

import React, { useEffect, useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import {
  setAchievementToastHandler,
  type AchievementToast as ToastData,
} from '../lib/achievements';

const AUTO_DISMISS_MS = 5_500;

const AchievementToast: React.FC = () => {
  const [toast, setToast] = useState<ToastData | null>(null);

  useEffect(() => {
    setAchievementToastHandler(t => {
      setToast(t);
      // Auto-dismiss
      window.setTimeout(() => {
        setToast(current => (current === t ? null : current));
      }, AUTO_DISMISS_MS);
    });
    return () => setAchievementToastHandler(null);
  }, []);

  if (!toast) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[10000] flex justify-center px-4 pb-4 sm:pb-6 pointer-events-none"
      style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
      role="status"
      aria-live="polite"
    >
      <div className="pointer-events-auto w-full max-w-md rounded-2xl shadow-2xl ring-1 ring-black/5 overflow-hidden animate-[achToastIn_0.45s_cubic-bezier(0.25,0.85,0.4,1.15)]">
        <div
          className="px-4 py-3.5 flex items-center gap-3"
          style={{
            background: 'linear-gradient(135deg, #C8A882 0%, #B89968 100%)',
          }}
        >
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center animate-[achPulse_1.5s_ease-in-out_infinite]">
            <Sparkles className="w-5 h-5 text-white" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-white">
              {toast.title}
            </div>
            <div className="text-xs text-white/85 mt-0.5 leading-snug">
              {toast.message}
            </div>
          </div>

          <button
            onClick={() => setToast(null)}
            className="flex-shrink-0 p-1 text-white/70 hover:text-white transition-colors"
            aria-label="Fermer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes achToastIn {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes achPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
};

export default AchievementToast;
